/* eslint-disable no-unused-vars  */
export enum Direction {
  TOP = 'DIRECTION_TOP',
  BOTTOM = 'DIRECTION_BOTTOM',
  LEFT = 'DIRECTION_LEFT',
  RIGHT = 'DIRECTION_RIGHT',
}